<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <div class="card">
      <card-header
        :title="pageTitle"
        :route="`/adicionarPessoa`"
      />
      <filter-person @filtrar="handleFilter" />

      <section class="section is-main-section">
        <card-component class="has-table has-mobile-sort-spaced">
          <!-- Modals -->
          <modal-delete-pessoa
            :is-active="isModalDeleteActive"
            :item="pessoaSelecionada"
            @confirm="handleModalClose"
            @cancel="handleModalClose"
          />

          <!-- Tabela -->
          <b-table
            :checked-rows.sync="checkedRows"
            :data="processedPessoas"
            default-sort="nome"
            striped
            hoverable
          >
            <b-table-column v-slot="props" label="Nome" field="nome" sortable>
              {{ props.row.nome }}
            </b-table-column>

            <b-table-column v-slot="props" label="CPF" field="cpf" sortable>
              {{ props.row.cpf | VMask("###.###.###-##") }}
            </b-table-column>

            <b-table-column
              v-slot="props"
              label="Ações"
              cell-class="is-actions-cell"
              centered
            >
              <action-buttons
                :item="props.row"
                :current-route="currentRoute"
                :toConfig="{
                  name: 'FormPessoa.edit',
                  params: { id: props.row.id },
                }"
                @delete="(p) => openModalDelete(p)"
              />
            </b-table-column>

            <template #empty>
              <empty-state />
            </template>
          </b-table>

          <!-- Paginação -->
          <pagination-section
            :current-page="pageable.current"
            :total-items="totalElements"
            :per-page="15"
            :current-query="$route.query"
            @page-change="handlePageChange"
          />
        </card-component>
      </section>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import PessoaService from "@/services/PessoaService.js";
import storage from "@/mixins/storage";

// Componentes
import TitleBar from "@/components/TitleBar.vue";
import CardComponent from "@/components/Cards/CardComponent.vue";
import ModalDeletePessoa from "@/components/Modals/ModalDeletePessoa.vue";
import ModalDesligamento from "@/components/Modals/ModalDesligamento.vue";
import FilterPerson from "@/components/Filters/FilterPerson.vue";
import CardHeader from "@/components/Cards/CardHeader.vue";
import ActionButtons from "@/components/ActionButtons.vue";
import EmptyState from "@/components/EmptyState.vue";
import PaginationSection from "@/components/PaginationSection.vue";


export default defineComponent({
  name: "ListPessoa",
  components: {
    TitleBar,
    CardComponent,
    ModalDeletePessoa,
    ModalDesligamento,
    FilterPerson,
    CardHeader,
    ActionButtons,
    EmptyState,
    PaginationSection,
  },

  mixins: [storage],

  data() {
    return {
      titleStack: ["SECAPI", "Pessoas", this.pageTitle],
      pessoas: [],
      pageable: {
        current: 1,
        size: 0,
      },
      totalElements: 0,
      isModalDeleteActive: false,
      isModalDesligarPessoaActive: false,
      pessoaSelecionada: null, // Variável unificada
      checkedRows: [],
      pageSize: 15,
    };
  },

  computed: {
    processedPessoas() {
      return this.pessoas.map((pessoa) => ({
        id: pessoa.id,
        nome: pessoa.nome,
        cpf: pessoa.cpf,
        empresa: pessoa.empresa?.razaoSocial,
        ativo: pessoa.ativo ? "ATIVO" : "INATIVO",
      }));
    },

    pageTitle() {
      const typeMap = {
        VISITANTE: "Visitantes",
        MOTORISTA: "Motoristas",
        FUNCIONARIO: "Funcionários",
      };
      return `Listar ${typeMap[this.currentRoute.query.tipoPessoa] ?? 'Pesssoas'}`;
    },

    currentRoute() {
      return this.$route;
    },
  },

  watch: {
    "$route.query": {
      immediate: true,
      async handler(query) {
        this.pageable.current = parseInt(query.page) || 1;
        await this.fetchData();
      },
    },
  },

  methods: {
    handlePageChange(newPage) {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: newPage,
        },
      });
    },
    async fetchData() {
      try {
        const response = await PessoaService.getPessoas(
          this.pageable.current - 1,
          this.$util.formatQueryUrl(this.currentRoute.query)
        );

        this.pessoas = response.data.content;
        this.totalElements = response.data.totalElements;
        this.pageable.size = response.data.totalElements;
      } catch (error) {
        this.handleError(error, "Erro ao carregar dados");
      }
    },

    async handleFilter(filtro) {
      const newQuery = {
        ...this.currentRoute.query,
        ...filtro,
        page: 1,
      };
      Object.keys(newQuery).forEach((key) => {
        if (!newQuery[key] && key !== "tipoPessoa") delete newQuery[key];
      });

      this.$router.push({ query: newQuery });
    },

    openModalDelete(pessoa) {
      this.pessoaSelecionada = pessoa; // Define a pessoa selecionada
      this.isModalDeleteActive = true; // Abre o modal de deleção
    },

    handleError(error, defaultMessage) {
      const errorMessage = error.response?.data?.message || defaultMessage;
      this.showToast(errorMessage, "is-danger");
      console.error(error);
    },

    handleModalClose() {
      this.isModalDeleteActive = false;
      this.isModalDesligarPessoaActive = false;
      this.pessoaSelecionada = null; // Limpa a pessoa selecionada
    },
  },
});
</script>
